import { DiagnosticsConstants } from './types';

export const initialState = {
  dataPointsList: undefined,
  diagnosticsData: {},
  graphDateRange: {
    value: '48Hours',
    label: 'Past 48 Hours',
    startDatetime: undefined,
    endDatetime: undefined,
  },
  error: undefined,
  isLoading: false,
  lineColorObj: undefined,
  availableColors: undefined,
  selectedDataPointsList: [],
};

export function diagnosticsReducer(state = initialState, action) {
  switch (action.type) {
    case DiagnosticsConstants.RequestDiagnosticsRegistries:
      return {
        ...state,
        isLoading: true,
      };
    case DiagnosticsConstants.ReceiveDiagnosticsRegistries:
      return {
        ...state,
        dataPointsList: action.payload,
      };
    case DiagnosticsConstants.RequestDiagnosticsOverview:
      return {
        ...state,
        isLoading: true,
      };
    case DiagnosticsConstants.ReceiveDiagnosticsOverview:
      return {
        ...state,
        diagnosticsData: action.payload,
        isLoading: false,
      };
    case DiagnosticsConstants.UpdateDiagnosticsDataRegistries:
      return {
        ...state,
        diagnosticsData: {
          ...state.diagnosticsData,
          registries: [...state.diagnosticsData.registries, ...action.payload],
        },
        isLoading: false,
      };
    case DiagnosticsConstants.RemoveDiagnosticsDataRegistries:
      return {
        ...state,
        diagnosticsData: {
          ...state.diagnosticsData,
          registries: action.payload,
        },
        isLoading: false,
      };
    case DiagnosticsConstants.UpdateGraphDateRange:
      return {
        ...state,
        graphDateRange: action.payload,
      };
    case DiagnosticsConstants.UpdateLineColorsObj:
      return {
        ...state,
        lineColorObj: action.payload,
      };
    case DiagnosticsConstants.UpdateAvailableColors:
      return {
        ...state,
        availableColors: action.payload,
      };
    case DiagnosticsConstants.SetDiagnosticsError:
      return {
        ...state,
        diagnosticsData: undefined,
        error: 'There was an error retrieving diagnostics data.',
        isLoading: false,
      };
    case DiagnosticsConstants.ClearDiagnosticsError:
      return {
        ...state,
        error: undefined,
        customDataPointsList: undefined,
      };
    case DiagnosticsConstants.UpdateSelectedDataPointsList:
      return {
        ...state,
        selectedDataPointsList: action.payload,
      };
    default:
      return state;
  }
}
